import "./MoveTask.scss";
import "../../../../components/ModalContent/ModalComponents.scss";
import { useState } from "react";
import { fetcher } from "../../../../utils/fetcher";
import { useTranslation } from "react-i18next";

function MoveTask({ task, taskGroups, closeMoveTask, onSave }) {
  const { t } = useTranslation();
  const [isMoving, setIsMoving] = useState(false);

  const handleMoveTask = async (sectionId) => {
    if (sectionId === task.sectionId) {
      return;
    }

    try {
      setIsMoving(true);

      // Update task with new sectionId
      // The backend will automatically move all subtasks to the same section
      await fetcher.put(`/api/tasks/${task._id}`, {
        sectionId: sectionId,
      });

      // Refresh parent to show updated task list
      if (onSave) {
        onSave();
      }

      // Close modal
      closeMoveTask();
    } catch (error) {
      console.error("Error moving task:", error);
      // alert("Failed to move task. Please try again.");
    } finally {
      setIsMoving(false);
    }
  };

  // Helper function to convert hex to rgba
  const hexToRgba = (hex, alpha = 1) => {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  };

  return (
    <div className="move-task-content">
      <div className="modal-title">
        <div>{t("tasks.modals.moveTask.title")}</div>
      </div>
      <div className="taskgroups-list-wrapper">
        {taskGroups
          .filter((group) => group._id !== task.sectionId)
          .map((group) => (
            <div
              key={group._id}
              className="taskgroup-item"
              style={{
                backgroundColor: hexToRgba(group.color, 0.8),
              }}
              onClick={() => !isMoving && handleMoveTask(group._id)}
            >
              <div className="taskgroup-name">{group.name}</div>
            </div>
          ))}
      </div>
    </div>
  );
}

export default MoveTask;
